export enum SubscriptionTypes {
  DIGITAL = 'digital',
  ON_SITE = 'on-site',
}
